import styled from '@emotion/styled';
import { Button, Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { peach } from 'constants/blogColors';
import { SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta } from 'graphql/__generated__/operations/SingleArticleQuery';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { Headline } from './CTACommonStyles';

type props = {
  inArticleCTA: SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta;
};
export const DownloadCTA = ({ inArticleCTA }: props) => {
  const { headline, buttonText, buttonUrl, image, subhead } = inArticleCTA;
  const trackEvent = useTrackEvent();

  return (
    <CTAWrapper>
      <ActionSection>
        <Headline>{headline}</Headline>
        <Subhead>{subhead}</Subhead>
        <ButtonWrapper>
          <Button
            target="_blank"
            href={buttonUrl!}
            color="black"
            onClick={() => {
              trackEvent('linkClicked', {
                linkText: `download ebook ${buttonUrl}`,
                href: buttonUrl!,
                component: 'ebook',
                path: window.location.pathname,
              });
            }}
          >
            {buttonText}
          </Button>
        </ButtonWrapper>
      </ActionSection>
      <Image src={image?.url!} alt="persona image" />
    </CTAWrapper>
  );
};

const CTAWrapper = styled.article`
  border-radius: 5px;
  background-color: ${peach};
  display: flex;
`;

const ActionSection = styled.section`
  padding: 30px 20px 40px 20px;
  text-align: center;
  flex: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${mediaQueries.tablet} {
    text-align: left;
    padding: 40px 30px 40px 30px;
  }
`;

const Image = styled.img`
  display: none;
  ${mediaQueries.tablet} {
    display: block;
  }
  flex: 1;
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
`;

const Subhead = styled.div`
  margin-top: 10px;
  color: ${Colors.grey900};
`;
